import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../../components/Button";
import DictionaryWordImportForm from "./DictionaryWordImportForm";
import DictionaryWordTextareaForm from "./DictionaryWordTextareaForm";

class DictionaryWordFromTextareaModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      saving: false,
    };

    this.formRef = React.createRef();

    this.toggleModal = this.toggleModal.bind(this);
    this.submit = this.submit.bind(this);
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen
    })
  }

  submit(){
    this.formRef.current.save()
  }

  render() {
    const {saving, modalOpen} = this.state;

    return <React.Fragment>
      <Button onClick={this.toggleModal} className="mr-2"><i className="fas fa-download" /> Utwórz nowe słowa</Button>

      <Modal isOpen={modalOpen} toggle={this.toggleModal} size="xl">
        <ModalHeader toggle={this.toggleModal}>Utwórz nowe słowa</ModalHeader>
        <ModalBody>
          <DictionaryWordTextareaForm
            dictionaryId={this.props.dictionaryId}
            onSaved={dictionary => {
              this.toggleModal();
              this.props.onCreated(dictionary);
            }}
            ref={this.formRef}
            onSavingStart={() => this.setState({ saving: true })}
            onSavingStop={() => this.setState({ saving: false })}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" className="mb-0" onClick={this.toggleModal}>Anuluj</Button>
          <Button
            loading={saving}
            onClick={this.submit}
          >Utwórz</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>;
  }
}

DictionaryWordFromTextareaModal.propTypes = {
  dictionaryId: PropTypes.string.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onCreated: PropTypes.func.isRequired,
};

export default DictionaryWordFromTextareaModal;
